<template>
    <PopupRouterViewDetail label="Picking Supply For Subcontract Detail" @hideMethod="onHidden" :isShowCopyData="false">

        <!-- APP_DETAIL_HEADER -->

        <b-card header="Picking Supply For Subcontract" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-label label-cols-lg="12" size="sm" type="generatednumber" label="Picking Supply For Subcontract No" :model="model.pickingSupplyForSubcontractNumber" />
						<app-input-combobox-autocomplete :options="workOrderSupplySubContracts" optionsLabel="materialIssueNumber" optionsKey="id" label-cols-lg="12" label="Work Order Supply (W/O No)" id="fieldset-work-order-supply-subcontract" size="sm" :model.sync="model.workOrderSupplySubcontractId"   :selected="model.workOrderSupplySubcontract != null ? model.workOrderSupplySubcontract.materialIssueNumber : ''" @input="getWorkOrderSupplySubContracts" @change="updateData" :isEditable="isUpdatable" :isUpdatable="isUpdatable" :isSelectMethodExists="true" @onSelectMethod="setSelectedWorkOrderSupplySubcontract" />
						<app-input-combobox-autocomplete :options="documentStatuss" optionsLabel="name" optionsKey="id" label-cols-lg="12" label="Document Status" id="fieldset-document-status" size="sm" :model.sync="model.documentStatusId"   :selected="model.documentStatus != null ? model.documentStatus.name : ''" @input="getDocumentStatuss" @change="updateData" :isEditable="isUpdatable" :isUpdatable="isUpdatable"  :isSelectMethodExists="true" @onSelectMethod="setSelectedDocumentStatus" />
						<app-input-datepicker  id="fieldset-material-issue-date" label-cols-lg="12"  label="Material Issue Date" size="sm" :model.sync="model.materialIssueDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" @change="updateData" :isEditable="isUpdatable" :isUpdatable="isUpdatable" />
					</b-col>
					<b-col cols="12" lg="6">
				</b-col>

            </b-row>
        </b-card>

		<app-table-input-popup title="Material Issue Part" :bordered="true" :items="pickingSupplyForSubcontractDetails" :fields="fieldsPickingSupplyForSubcontractDetail" :busy="isDataLoading" :sort-by.sync="sortByPickingSupplyForSubcontractDetail" :sort-desc.sync="sortDescPickingSupplyForSubcontractDetail" small responsive
			@editButtonMethod="editRowDataPickingSupplyForSubcontractDetail"
			@deleteButtonMethod="deleteRowDataPickingSupplyForSubcontractDetail"
			@showPopupAddMethod="resetDataPickingSupplyForSubcontractDetail()"
			@showPopupUploadMethod="showPopupUploadPickingSupplyForSubcontractDetail()"
			@downloadMethod="downloadPickingSupplyForSubcontractDetail()"
			@addFromClipboardMethod="addFromClipboardPickingSupplyForSubcontractDetail()"
			@replaceFromClipboardMethod="replaceFromClipboardPickingSupplyForSubcontractDetail()"
			:showActionButton="isUpdatable"
			:showEditButton="false"
			:showDeleteButton="isUpdatable"
			:showAddButton="isUpdatable"
			:showAddFromClipboardButton="false"
			:showReplaceFromClipboardButton="false"
			:showUploadButton="false"
			:showDownloadButton="false"
			:isDownloadBusy="isDownloadPickingSupplyForSubcontractDetail"
			>
			<template #top-row v-if="isShowPickingSupplyForSubcontractDetailFilter">
				<b-th></b-th>
				<b-th></b-th>
				<b-th stacked-heading="Work Order Supply For Subcon Detail">
					<v-select append-to-body label="part" :options="workOrderSupplySubContractDetails"  :value="filterPickingSupplyForSubcontractDetail.workOrderSupplyForSubconDetailId" :reduce="item => item.id" v-model="filterPickingSupplyForSubcontractDetail.workOrderSupplyForSubconDetailId" @search="getWorkOrderSupplySubContractDetails" :filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="Part">
					<v-select append-to-body label="partNumber" :options="parts"  :value="filterPickingSupplyForSubcontractDetail.partId" :reduce="item => item.id" v-model="filterPickingSupplyForSubcontractDetail.partId" @search="getParts" :filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="Supply Qty">
					<b-form-input id="input-supply-qty-table" v-model="filterPickingSupplyForSubcontractDetail.supplyQty" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Actual Qty">
					<b-form-input id="input-actual-qty-table" v-model="filterPickingSupplyForSubcontractDetail.actualQty" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Is Complete">
					<b-form-checkbox id="input-is-completed-table" class="float-right" v-model="filterPickingSupplyForSubcontractDetail.isCompleted"></b-form-checkbox>
				</b-th>
				<b-th stacked-heading="Process By">
					<v-select append-to-body label="firstName" :options="userInfos"  :value="filterPickingSupplyForSubcontractDetail.processById" :reduce="item => item.id" v-model="filterPickingSupplyForSubcontractDetail.processById" @search="getUserInfos" :filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="Process Date">
					<app-input-datetimepicker-range id="fieldset-process-date" label-cols-sm="4" label-cols-lg="3" :nolabel="true" label="Process Date" size="sm" :modelFrom.sync="filterPickingSupplyForSubcontractDetail.processDateFrom" :modelTo.sync="filterPickingSupplyForSubcontractDetail.processDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button/>
				</b-th>
				<b-th stacked-heading="Remarks">
					<b-form-input id="input-remarks-table" v-model="filterPickingSupplyForSubcontractDetail.remarks" size="sm"></b-form-input>
				</b-th>

				<b-th></b-th>
			</template>
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( pickingSupplyForSubcontractDetailPageSize * (currentPickingSupplyForSubcontractDetailPage - 1))) }}
			</template>
			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>
			<template v-slot:cell(workOrderSupplyForSubconDetail)="row">
				<app-input-combobox-autocomplete :options="workOrderSupplySubContractDetails" optionsLabel="part" optionsKey="id" :id="'input-picking-supply-for-subcontract-detail-work-order-supply-for-subcon-detail-' + row.index" label-cols-lg="12" label="Work Order Supply For Subcon Detail" size="sm" :model.sync="row.item.workOrderSupplyForSubconDetailId"  @change="saveInputPickingSupplyForSubcontractDetail(row.item)" :selected="row.item.workOrderSupplyForSubconDetail != null ? row.item.workOrderSupplyForSubconDetail.part : ''"  @input="getWorkOrderSupplySubContractDetails" :loading="isWorkOrderSupplySubContractDetailComboLoading"  :isEditable="isUpdatable" :isUpdatable="isUpdatable"   :nolabel="true" />
			</template>
			<template v-slot:cell(part)="row">
				<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" :id="'input-picking-supply-for-subcontract-detail-part-' + row.index" label-cols-lg="12" label="Part" size="sm" :model.sync="row.item.partId"  @change="saveInputPickingSupplyForSubcontractDetail(row.item)" :selected="row.item.part != null ? row.item.part.partNumber : ''"  @input="getParts" :loading="isPartComboLoading" :isEditable="isUpdatable" :isUpdatable="isUpdatable"  :nolabel="true" />
			</template>
			<template v-slot:cell(supplyQty)="row">
				<app-input-textbox :id="'input-picking-supply-for-subcontract-detail-supply-qty-' + row.index" label-cols-lg="12" label="Supply Qty" size="sm" :model.sync="row.item.supplyQty"   @change="saveInputPickingSupplyForSubcontractDetail(row.item)" :isEditable="isUpdatable" :isUpdatable="isUpdatable"  :nolabel="true" />
			</template>
			<template v-slot:cell(actualQty)="row">
				<app-input-textbox :id="'input-picking-supply-for-subcontract-detail-actual-qty-' + row.index" label-cols-lg="12" label="Actual Qty" size="sm" :model.sync="row.item.actualQty"   @change="saveInputPickingSupplyForSubcontractDetail(row.item)" :isEditable="isUpdatable" :isUpdatable="isUpdatable"   :nolabel="true" />
			</template>
			<template v-slot:cell(isCompleted)="row">
				<app-input-checkbox :id="'input-picking-supply-for-subcontract-detail-is-completed-row-' + row.index" label-cols-lg="12" label="Is Complete" :model.sync="row.item.isCompleted" @change="saveInputPickingSupplyForSubcontractDetail(row.item)" :isEditable="isUpdatable" :isUpdatable="isUpdatable"   :nolabel="true"></app-input-checkbox>
			</template>
			<template v-slot:cell(processBy)="row">
				<app-input-combobox-autocomplete :options="userInfos" optionsLabel="firstName" optionsKey="userName" :id="'input-picking-supply-for-subcontract-detail-process-by-' + row.index" label-cols-lg="12" label="Process By" size="sm" :model.sync="row.item.processById"  @change="saveInputPickingSupplyForSubcontractDetail(row.item)" :selected="row.item.processBy != null ? row.item.processBy.firstName : ''"  @input="getUserInfos" :loading="isUserInfoComboLoading"  :isEditable="isUpdatable" :isUpdatable="isUpdatable"   :nolabel="true" />
			</template>
			<template v-slot:cell(processDate)="row">
				{{row.item.processDate| moment('DD MMMM YYYY HH:mm')}}
			</template>
			<template v-slot:cell(remarks)="row">
				<app-input-textarea :id="'input-picking-supply-for-subcontract-detail-remarks-' + row.index" label-cols-lg="12" label="Remarks" size="sm" :model.sync="row.item.remarks"  @change="saveInputPickingSupplyForSubcontractDetail(row.item)" :isEditable="isUpdatable" :isUpdatable="isUpdatable"  :nolabel="true" />
			</template>

			<template v-slot:form-add-detail>
				<PickingSupplyForSubcontractDetailInput 
					:openPopup="isShowPopupPickingSupplyForSubcontractDetail"
					:modelId="pickingSupplyForSubcontractDetailId"
					@resetMethod="resetModal"
					@addButtonMethod="addRowDataPickingSupplyForSubcontractDetail"/>
			</template>
			<template v-slot:upload-detail>
				<PickingSupplyForSubcontractDetailUpload
					:openPopup="isShowPopupUploadPickingSupplyForSubcontractDetail"
					@resetMethod="resetModal"
					@uploadButtonMethod="uploadDataPickingSupplyForSubcontractDetail"
					:parentId="modelId"
					/>
			</template>
			<template #row-details="row">
				<b-card>
					<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" :id="'input-picking-supply-for-subcontract-detail-part-' + row.index" label-cols-lg="12" label="Part" size="sm" :model.sync="row.item.partId"  @change="saveInputPickingSupplyForSubcontractDetail(row.item)" :selected="row.item.part != null ? row.item.part.partNumber : ''"  @input="getParts" :loading="isPartComboLoading"  :isUpdatable="false" :isEditable="false"  />
					<app-input-textbox :id="'input-picking-supply-for-subcontract-detail-supply-qty-' + row.index" label-cols-lg="12" label="Supply Qty" size="sm" :model.sync="row.item.supplyQty"   @change="saveInputPickingSupplyForSubcontractDetail(row.item)" :isUpdatable="false" :isEditable="false"  />
					<app-input-textbox :id="'input-picking-supply-for-subcontract-detail-actual-qty-' + row.index" label-cols-lg="12" label="Actual Qty" size="sm" :model.sync="row.item.actualQty"   @change="saveInputPickingSupplyForSubcontractDetail(row.item)" :isUpdatable="false" :isEditable="false"  />
					<app-input-checkbox :id="'input-picking-supply-for-subcontract-detail-is-completed-row-' + row.index" label-cols-lg="12" label="Is Complete" :model.sync="row.item.isCompleted" @change="saveInputPickingSupplyForSubcontractDetail(row.item)" :isUpdatable="false" :isEditable="false" ></app-input-checkbox>
					<app-input-combobox-autocomplete :options="userInfos" optionsLabel="firstName" optionsKey="userName" :id="'input-picking-supply-for-subcontract-detail-process-by-' + row.index" label-cols-lg="12" label="Process By" size="sm" :model.sync="row.item.processById"  @change="saveInputPickingSupplyForSubcontractDetail(row.item)" :selected="row.item.processBy != null ? row.item.processBy.firstName : ''"  @input="getUserInfos" :loading="isUserInfoComboLoading"  :isUpdatable="false" :isEditable="false"  />
					<app-input-datetimepicker :id="'input-picking-supply-for-subcontract-detail-process-date-' + row.index" label-cols-lg="12" label="Process Date" size="sm" :model.sync="row.item.processDate"   @change="saveInputPickingSupplyForSubcontractDetail(row.item)" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" :isUpdatable="false" :isEditable="false"  />
					<app-input-textarea :id="'input-picking-supply-for-subcontract-detail-remarks-' + row.index" label-cols-lg="12" label="Remarks" size="sm" :model.sync="row.item.remarks"  @change="saveInputPickingSupplyForSubcontractDetail(row.item)" :isUpdatable="false" :isEditable="false"  />
				</b-card>
			</template>

		</app-table-input-popup>
        <!-- END_APP_DETAIL_HEADER -->

        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterViewDetail>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import PickingSupplyForSubcontract from '@/models/PickingSupplyForSubcontract/PickingSupplyForSubcontract';
import PickingSupplyForSubcontractList from '@/models/PickingSupplyForSubcontract/PickingSupplyForSubcontractList';
import PickingSupplyForSubcontractFilter from '@/filters/PickingSupplyForSubcontract/PickingSupplyForSubcontractFilter';

import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';

import AppLabel from '@/components/AppLabel';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import WorkOrderSupplySubContract from '@/models/WorkOrderSupplySubContract/WorkOrderSupplySubContract';
import WorkOrderSupplySubContractFilter from '@/filters/WorkOrderSupplySubContract/WorkOrderSupplySubContractFilter';
import DocumentStatus from '@/models/DocumentStatus/DocumentStatus';
import DocumentStatusFilter from '@/filters/DocumentStatus/DocumentStatusFilter';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import PickingSupplyForSubcontractDetail from '@/models/PickingSupplyForSubcontract/PickingSupplyForSubcontractDetail';
import PickingSupplyForSubcontractDetailFilter from '@/filters/PickingSupplyForSubcontract/PickingSupplyForSubcontractDetailFilter';
import WorkOrderSupplySubContractDetail from '@/models/WorkOrderSupplySubContract/WorkOrderSupplySubContractDetail';
import WorkOrderSupplySubContractDetailFilter from '@/filters/WorkOrderSupplySubContract/WorkOrderSupplySubContractDetailFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputCheckbox from '@/components/AppInputCheckbox';
import UserInfo from '@/models/UserInfo/UserInfo';
import UserInfoFilter from '@/filters/UserInfo/UserInfoFilter';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
import AppInputTextarea from '@/components/AppInputTextarea';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import PickingSupplyForSubcontractDetailInput from '@/views/PickingSupplyForSubcontract/PickingSupplyForSubcontractDetailInput';
import PickingSupplyForSubcontractDetailUpload from '@/views/PickingSupplyForSubcontract/PickingSupplyForSubcontractDetailUpload';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppLabel,
		AppInputComboboxAutocomplete,
		AppInputDatepicker,
		AppInputDatepickerRange,
		AppInputTextbox,
		AppInputCheckbox,
		AppInputDatetimepicker,
		AppInputDatetimepickerRange,
		AppInputTextarea,
		PickingSupplyForSubcontractDetailInput,PickingSupplyForSubcontractDetailUpload,
		AppTableInput,
		AppTableInputPopup,
		PopupRouterViewDetail,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
		},
	},
	data() {
		return {
			errorMessage : {
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			fieldsPickingSupplyForSubcontractDetail: [
				{"frontActions": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number d-stack-none"}}, 
				// {"workOrderSupplyForSubconDetail": { "class" : "th-work-order-supply-for-subcon-detail first-child", "label" : "Work Order Supply For Subcon Detail", key: 'workOrderSupplyForSubconDetail', sortable: false}}, 
				{"part": { "class" : "th-part", "label" : "Part", key: 'part', sortable: false}}, 
				{"supplyQty": { "class" : "th-supply-qty last-child", "label" : "Supply Qty", key: 'supplyQty', sortable: false}}, 
				{"actualQty": { "class" : "th-actual-qty d-stack-none", "label" : "Actual Qty", key: 'actualQty', sortable: false}}, 
				{"isCompleted": { "class" : "th-is-completed d-stack-none", "label" : "Is Complete", key: 'isCompleted', sortable: false}}, 
				{"processBy": { "class" : "th-process-by d-stack-none", "label" : "Process By", key: 'processBy', sortable: false}}, 
				{"processDate": { "class" : "th-process-date d-stack-none", "label" : "Process Date", key: 'processDate', sortable: false}}, 
				{"remarks": { "class" : "th-remarks d-stack-none", "label" : "Remarks", key: 'remarks', sortable: false}}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			modelPickingSupplyForSubcontractDetail : {},
			isShowPopupPickingSupplyForSubcontractDetail : false,
			isShowPopupUploadPickingSupplyForSubcontractDetail : false,
			filterPickingSupplyForSubcontract : null,
			currentPickingSupplyForSubcontractPage : 1,
			pickingSupplyForSubcontractPageSize: 10,
			sortByPickingSupplyForSubcontract: '',
			sortDescPickingSupplyForSubcontract: '',
			filterPickingSupplyForSubcontractDetail : null,
			currentPickingSupplyForSubcontractDetailPage : 1,
			pickingSupplyForSubcontractDetailPageSize: 10,
			sortByPickingSupplyForSubcontractDetail: '',
			sortDescPickingSupplyForSubcontractDetail: '',
			sortingByPickingSupplyForSubcontractDetail: [],
			pickingSupplyForSubcontractDetails : [],
			pickingSupplyForSubcontractDetailId : '',
			totalPickingSupplyForSubcontractDetailRow : 0,
			isShowPickingSupplyForSubcontractDetailFilter: false,
			isDownloadPickingSupplyForSubcontractDetail: false,
			workOrderSupplySubContractDetails: [],
			parts: [],
			userInfos: [],
			workOrderSupplySubContracts: [],
			workOrderSupplySubcontracts: [],
			isWorkOrderSupplySubcontractComboLoading: false,
			documentStatuss: [],
			documentStatuss: [],
			isDocumentStatusComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isWorkOrderSupplySubContractComboLoading: false,
			isDocumentStatusComboLoading: false,
			isPickingSupplyForSubcontractComboLoading: false,
			isWorkOrderSupplySubContractDetailComboLoading: false,
			isPartComboLoading: false,
			isUserInfoComboLoading: false,
			isUpdatable : false
		}
	},
	methods : {
		showPopupWithMessage : async function(message) {
			const msg = this.$createElement;
			let msgNode = '';
			let result = false;
			msgNode = msg('div', { domProps: { innerHTML: '<p>'+message+'</p>' } })
			await this.$bvModal.msgBoxConfirm([msgNode], {
				title: 'Alert',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				cancelVariant: 'secondary',
				okTitle: 'Yes',
				cancelTitle: 'No',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(e=>{
				if(e){
					result = true;
				}
			});
			return result;
		},
		getPickingSupplyForSubcontract : async function(id) {
			this.isBusy = true;
			PickingSupplyForSubcontract.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadPickingSupplyForSubcontract = true;
			this.filterPickingSupplyForSubcontract.id = this.modelId;
			PickingSupplyForSubcontract.downloadDataDetail(this, this.filterPickingSupplyForSubcontract).then(result => {
				this.isDownloadPickingSupplyForSubcontract = false;
			}).catch(error => { this.isDownloadPickingSupplyForSubcontract = false; })
		},
		getPickingSupplyForSubcontractDetails : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterPickingSupplyForSubcontractDetail);
			if (this.modelId == null) return;
			filter.pickingSupplyForSubcontractId = this.modelId;
			filter.draftMode = "0";
			if (this.sortByPickingSupplyForSubcontractDetail != null) {
				this.sortingByPickingSupplyForSubcontractDetail[this.sortByPickingSupplyForSubcontractDetail] = this.sortDescPickingSupplyForSubcontractDetail;
			}
			let currentPage = (this.currentPickingSupplyForSubcontractDetailPage - 1);
			if (isAddRow) {
				let totalData = this.totalPickingSupplyForSubcontractDetailRow + 1;
				let page = Math.ceil(totalData/this.pickingSupplyForSubcontractDetailPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.pickingSupplyForSubcontractDetailPageSize = 0;
			// disable paging end
			PickingSupplyForSubcontractDetail.getList(this, filter, this.sortingByPickingSupplyForSubcontractDetail, currentPage , this.pickingSupplyForSubcontractDetailPageSize).then(result => {
				this.currentPickingSupplyForSubcontractDetailPage = currentPage + 1;
				this.pickingSupplyForSubcontractDetails = result.data;
				this.totalPickingSupplyForSubcontractDetailRow = result.dataCount;
			}).catch(error => {});
		},
		getPickingSupplyForSubcontracts : async function(input) {
			let filter = new PickingSupplyForSubcontractFilter();
			if (input != undefined) {
				filter.PickingSupplyForSubcontractNumber = input;
			}
			this.isPickingSupplyForSubcontractComboLoading = true;
			PickingSupplyForSubcontract.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.pickingSupplyForSubcontracts = result.data
				}
				this.isPickingSupplyForSubcontractComboLoading = false;
			})
			.catch(error => {});
		},
		getPickingSupplyForSubcontracts : async function(input) {
			let filter = new PickingSupplyForSubcontractFilter();
			if (input != undefined) {
				filter.pickingSupplyForSubcontractNumber = input;
			}
			this.isPickingSupplyForSubcontractComboLoading = true;
			PickingSupplyForSubcontract.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.pickingSupplyForSubcontracts = result.data
				}
				this.isPickingSupplyForSubcontractComboLoading = false;
			})
			.catch(error => {});
		},
		getWorkOrderSupplySubContractDetails : async function(input) {
			let filter = new WorkOrderSupplySubContractDetailFilter();
			if (input != undefined) {
				filter.part = input;
			}
			this.isWorkOrderSupplySubContractDetailComboLoading = true;
			WorkOrderSupplySubContractDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.workOrderSupplySubContractDetails = result.data
				}
				this.isWorkOrderSupplySubContractDetailComboLoading = false;
			})
			.catch(error => {});
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			this.isPartComboLoading = true;
			Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
				this.isPartComboLoading = false;
			})
			.catch(error => {});
		},
		getUserInfos : async function(input) {
			let filter = new UserInfoFilter();
			if (input != undefined) {
				filter.firstName = input;
			}
			this.isUserInfoComboLoading = true;
			UserInfo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.userInfos = result.data
				}
				this.isUserInfoComboLoading = false;
			})
			.catch(error => {});
		},
		getWorkOrderSupplySubContracts : async function(input) {
			let filter = new WorkOrderSupplySubContractFilter();
			if (input != undefined) {
				filter.materialIssueNumber = input;
			}
			filter.fwDocStat = '0,1';
			filter.exactType.fwDocStat = '1';
			WorkOrderSupplySubContract.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.workOrderSupplySubContracts = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedWorkOrderSupplySubcontractExecuted(item) {
			let _this = this;
			if(item == undefined || item == null) {
				this.model.workOrderSupplySubcontractId = null;
				this.model.workOrderSupplySubcontract = null;
				this.isBusy = true;
				PickingSupplyForSubcontract.resetDocument(this, this.model.id).then(result => {
					this.getPickingSupplyForSubcontract(this.model.id).then(result => {
						this.getPickingSupplyForSubcontractDetails();
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}).catch(error => { this.isBusy = false; });
			} else {
				this.model.workOrderSupplySubcontractId = item.id;
				this.model.workOrderSupplySubcontract = item;

				this.isBusy = true;
				PickingSupplyForSubcontract.copyFromDocument(this, 'workordersupplysubcontract', item.id, this.model.id).then(result => {
					this.getPickingSupplyForSubcontract(this.model.id).then(result => {
						this.getPickingSupplyForSubcontractDetails();
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}).catch(error => { this.isBusy = false; });
			}
		},
		setSelectedWorkOrderSupplySubcontract(item) {
			if(item) {
				var itemId = Number(item.id);
				if(this.model.workOrderSupplySubcontractId == itemId) return;
			}

			if(this.pickingSupplyForSubcontractDetails != null && this.pickingSupplyForSubcontractDetails.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap Picking Supply For Subcontract akan me-reset form yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if (value) {
						this.setSelectedWorkOrderSupplySubcontractExecuted(item);
					}
				})
				.catch(err => {})
			} else {
				this.setSelectedWorkOrderSupplySubcontractExecuted(item);
			}
		},
		getDocumentStatuss : async function(input) {
			let filter = new DocumentStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			DocumentStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.documentStatuss = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedDocumentStatus(item) {
			if(item == undefined || item == null) {
				this.model.documentStatusId = null;
				this.model.documentStatus = null;
			} else {
				this.model.documentStatusId = item.id;
				this.model.documentStatus = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.pickingSupplyForSubcontractInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				if (id != '' && id != null && id != undefined) {
					PickingSupplyForSubcontract.commitData(this, model, id).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'pickingsupplyforsubcontractindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				} else {
					PickingSupplyForSubcontract.insertData(this, model).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'pickingsupplyforsubcontractindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}
			}
		},
		updateData() {
			return;
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					PickingSupplyForSubcontract.updateDataDetail(this, model, id)
					.catch((error) => {
						this.getPickingSupplyForSubcontract(id);
					});
				}
			});
		},
		onHidden() {
			this.getPickingSupplyForSubcontracts();
		},
		addRowDataPickingSupplyForSubcontractDetail(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.pickingSupplyForSubcontractId =  this.modelId;
					PickingSupplyForSubcontractDetail.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getPickingSupplyForSubcontractDetails(true);
						this.isShowPopupPickingSupplyForSubcontractDetail = false;
					})
				} else {
					model.pickingSupplyForSubcontractId =  this.modelId;
					PickingSupplyForSubcontractDetail.createDataDetail(this, model)
					.then(result => {
						this.getPickingSupplyForSubcontractDetails(true);
						this.isShowPopupPickingSupplyForSubcontractDetail = false;
					})
				}
			}
		},
		async editRowDataPickingSupplyForSubcontractDetail(id) {
			this.pickingSupplyForSubcontractDetailId = id;
			this.isShowPopupPickingSupplyForSubcontractDetail = true; 
		},
		async deleteRowDataPickingSupplyForSubcontractDetail(id) {
			PickingSupplyForSubcontractDetail.deleteData(this, id).then(result => { this.getPickingSupplyForSubcontractDetails(); });
		},
		async resetDataPickingSupplyForSubcontractDetail() {
			this.pickingSupplyForSubcontractDetailId = "";
			this.isShowPopupPickingSupplyForSubcontractDetail = true;
		},
		async addDataPickingSupplyForSubcontractDetail() {
			PickingSupplyForSubcontractDetail.createData(this, { pickingSupplyForSubcontractId: this.modelId })
			.then(result => {
				this.getPickingSupplyForSubcontractDetails(true);
			})
		},
		async addFromClipboardPickingSupplyForSubcontractDetail() {
			let workOrderSupplyForSubconDetails = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					workOrderSupplyForSubconDetails.push({ workOrderSupplyForSubconDetail: item, pickingSupplyForSubcontractId: this.modelId });
				});
				PickingSupplyForSubcontractDetail.addFromClipboard(this, workOrderSupplyForSubconDetails).then(result => { this.getPickingSupplyForSubcontractDetails() });
			});
		},
		async replaceFromClipboardPickingSupplyForSubcontractDetail() {
			let workOrderSupplyForSubconDetails = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					workOrderSupplyForSubconDetails.push({ workOrderSupplyForSubconDetail: item, pickingSupplyForSubcontractId: this.modelId });
				});
				PickingSupplyForSubcontractDetail.replaceFromClipboard(this, workOrderSupplyForSubconDetails).then(result => { this.getPickingSupplyForSubcontractDetails() });
			});   
		},
		showPopupUploadPickingSupplyForSubcontractDetail() {
			if(this.pickingSupplyForSubcontractDetails != null && this.pickingSupplyForSubcontractDetails.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap PickingSupplyForSubcontractDetail akan me-reset data yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if (value) {
						this.isShowPopupUploadPickingSupplyForSubcontractDetail = true;
					}
				})
				.catch(err => {})
			} else {
				this.isShowPopupUploadPickingSupplyForSubcontractDetail = true;
			}
		},
		uploadDataPickingSupplyForSubcontractDetail(modalEvent, newDatas) {
			this.isShowPopupUploadPickingSupplyForSubcontractDetail = false; 
		},
		downloadPickingSupplyForSubcontractDetail(modalEvent) {
			this.isDownloadPickingSupplyForSubcontractDetail = true;
			this.filterPickingSupplyForSubcontractDetail.pickingSupplyForSubcontractId = this.modelId;
			PickingSupplyForSubcontractDetail.downloadDataDetail(this, this.filterPickingSupplyForSubcontractDetail).then(result => {
				this.isDownloadPickingSupplyForSubcontractDetail = false;
			}).catch(error => { this.isDownloadPickingSupplyForSubcontractDetail = false; })
		},
		saveInputPickingSupplyForSubcontractDetail(item) {
			return;
			if (this.pickingSupplyForSubcontracts != null && this.pickingSupplyForSubcontracts != undefined  && this.pickingSupplyForSubcontracts.length > 0) {
				item.pickingSupplyForSubcontract = this.pickingSupplyForSubcontracts.find(q => q.id == item.pickingSupplyForSubcontractId);
			}
			if (this.workOrderSupplySubContractDetails != null && this.workOrderSupplySubContractDetails != undefined  && this.workOrderSupplySubContractDetails.length > 0) {
				item.workOrderSupplyForSubconDetail = this.workOrderSupplySubContractDetails.find(q => q.id == item.workOrderSupplyForSubconDetailId);
			}
			if (this.parts != null && this.parts != undefined  && this.parts.length > 0) {
				item.part = this.parts.find(q => q.id == item.partId);
			}
			if (this.userInfos != null && this.userInfos != undefined  && this.userInfos.length > 0) {
				item.processBy = this.userInfos.find(q => q.id == item.processByUserName);
			}

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					PickingSupplyForSubcontractDetail.updateDataDetail(this, item, item.id);
				}
			});
		},
		resetModal(modalType) {
			this.isShowPopupUploadPickingSupplyForSubcontractDetail = false; 
			this.isShowPopupPickingSupplyForSubcontractDetail = false; 
			if (modalType == 'PickingSupplyForSubcontractDetail') {
				this.getPickingSupplyForSubcontractDetails();
			}
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
				//this.isShowPickingSupplyForSubcontractDetailFilter = true;
			}
		},
	},
	beforeMount() {
		this.filterPickingSupplyForSubcontract = new PickingSupplyForSubcontractFilter();
		this.filterPickingSupplyForSubcontractDetail = new PickingSupplyForSubcontractDetailFilter();
		//this.getPickingSupplyForSubcontracts();
		//this.getWorkOrderSupplySubContractDetails();
		//this.getParts();
		//this.getUserInfos();
		//this.getWorkOrderSupplySubContracts();
		//this.getDocumentStatuss();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getPickingSupplyForSubcontract(id);
			} else {
				this.modelId = id;
				this.getPickingSupplyForSubcontract(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				if(this.model.mainRecordId != undefined || this.model.mainRecordId != null) return false;
				return true;
			}
		}
	},
	watch : {
		sortByPickingSupplyForSubcontractDetail : {
			handler: function() {
				this.getPickingSupplyForSubcontractDetails();
			}
		},
		sortDescPickingSupplyForSubcontractDetail: {
			handler: function() {
				this.getPickingSupplyForSubcontractDetails();
			}
		},
		currentPickingSupplyForSubcontractDetailPage: {
			handler: function() {
				this.getPickingSupplyForSubcontractDetails();
			}
		},
		pickingSupplyForSubcontractDetailPageSize : {
			handler: function() {
				this.getPickingSupplyForSubcontractDetails();
			}
		},
		filterPickingSupplyForSubcontractDetail: {
			handler: function() {
				this.getPickingSupplyForSubcontractDetails();
			},
			deep: true,
		},
	},
}
</script>
